/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IPositionType {
  FrameLines = 0,
  Bridle = 1,
  MooringLine = 2,
  Corner = 3,
  Ladder = 4,
  Cage = 5,
  Polygon = 6,
  InnerMooringLine = 7,
  BargeCorner = 8,
  ElectricityLine = 9,
}

export enum IPositionTypeOrdered {
  MooringLine,
  Corner,
  Bridle,
  FrameLines,
  Cage,
  Polygon,
  Ladder,
  ElectricityLine,
}
